import {requestGet, requestPost} from '@/utils/request';

const api = {
    LIST: '/op/violate_word_list',
    ADD: '/op/violate_word_add',
    UPDATE: '/op/violate_word_update',
    DEL: '/op/violate_word_del',
    IS_EXIST: '/op/violate_word_is_exist',
}

export async function violateWordList(queryParams) {
    return requestGet(api.LIST, queryParams);
}

export async function violateWordAdd(form) {
    return requestPost(api.ADD, form);
}

export async function violateWordUpdate(form) {
    return requestPost(api.UPDATE, form);
}

export async function violateWordDel(id) {
    let params = {
        id: id,
    };
    return requestPost(api.DEL, params);
}

export async function violateWordIsExist(val) {
    const params = { val };
    return requestGet(api.IS_EXIST, params);
}

